import { SimpleObjectInterface } from '@thewhite/react-global-module/lib/interfaces';
import { TypeService } from '@thewhite/react-global-module/lib/services';

export enum BaseStatusEnum {
    ACTIVE = 'ACTIVE',
    DELETED = 'DELETED',
    DEACTIVATED = 'DEACTIVATED',
}

export interface BaseStatusParams {
    [value: string]: SimpleObjectInterface;

    ACTIVE: SimpleObjectInterface;
    DELETED: SimpleObjectInterface;
    DEACTIVATED: SimpleObjectInterface;
}

const BASE_STATUS: BaseStatusParams = {
    ACTIVE: {
        name: 'Активный',
        value: 'ACTIVE',
    },
    DELETED: {
        name: 'Удаленный',
        value: 'DELETED',
    },
    DEACTIVATED: {
        name: 'Деактивированный',
        value: 'DEACTIVATED',
    },
}

export default BASE_STATUS;

export const BaseStatusEnumType = TypeService.createEnum<BaseStatusEnum>(BaseStatusEnum, 'BaseStatusEnum')
